import "core-js/modules/es.array.push.js";
export default {
  name: "nft",
  data() {
    const nftMenu = [{
      label: "Buy NFT Shards",
      icon: require("@images/tapcoin/new/niceLucky/icon-buy.png"),
      path: ""
    }, {
      label: "Shard Draw",
      icon: require("@images/tapcoin/new/niceLucky/icon-shard.png"),
      path: "/nftLucky"
    }, {
      label: "Tasks",
      icon: require("@images/tapcoin/new/niceLucky/icon-task.png"),
      path: ""
    }];
    return {
      nftMenu
    };
  },
  methods: {
    onMenu(item) {
      this.$router.push(item);
    }
  }
};